import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  useMediaQuery,
  Tabs,
  Paper,
  Tab,
  Box,
  Chip,
  Avatar,
} from "@mui/material";
import BasicInfo from "./BasicInfo";
import ExperienceInfo from "./ExperienceInfo";
import EducationInfo from "./EducationInfo";
import Certifications from "./CertificationInfo";
import DocumentList from "./DocList";
import CandidateInterviewStatus from "./InterviewStatus";
import { useCandidateLayout } from "../../Components/Context/CandidateLayoutContext";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

const CandidateProfilePage = ({ isDash }) => {
  const { candidateData, candidateJobData } = useCandidateLayout();

  const [selectedTab, setSelectedTab] = useState(0);
  const [documents, setDocuments] = useState([]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const fetchDocuments = async () => {
    try {
      const res = await axiosAPI.get(
        `Candidate/getCandidateDocumentsPortal/${candidateData?.CI_Id}`
      );

      if (res?.data?.success) {
        setDocuments(res?.data?.data);
      }
    } catch (err) {
      console.error("Error fetching process flow data:", err);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [candidateData]);

  const [tabs, setTabs] = useState(["Basic Information"]);

  useEffect(() => {
    if (documents?.length > 0) {
      setTabs(["Basic Information", "Documents"]);
    }
  }, [documents]);

  const isMobile = useMediaQuery("(max-width: 1220px)");

  return (
    <Paper
      sx={{
        maxWidth: isMobile ? "100vw" : `calc(100vw - 300px)`,
        padding: 3,
        paddingTop:0,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      {!isDash && 
      <>
        <Typography
          sx={{
            fontFamily: "Geist, sans-serif",
            letterSpacing: `0.5px`,
            fontSize: "26px",
            color: "#333",
            fontWeight: "600",
          }}
          mb={2}
        >
          Profile
        </Typography>
        <Grid container spacing={2} alignItems="center" mb={2}>
          <Grid item>
            <Avatar
              src={`${process.env.REACT_APP_BASE_URL}/${candidateData.CI_Photo}`}
              sx={{
                width: 140,
                height: 140,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #ccc",
                boxShadow: 2,
                mx: "auto",
              }}
            >
              {candidateData?.CI_Name ? candidateData?.CI_Name[0] : ""}
            </Avatar>
          </Grid>

          <Grid item>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
            >
              {candidateData?.CI_Name || "-"}
            </Typography>
            <Typography sx={{ fontFamily: "Geist, sans-serif" }} variant="body1">
              {candidateData?.CI_Profession || "-"}
            </Typography>
            <Typography
              sx={{ fontFamily: "Geist, sans-serif" }}
              variant="body2"
              color="text.secondary"
            >
              Passport No: {candidateData?.CI_PassportNo || "-"}
            </Typography>
          </Grid>
        </Grid>
      </>
      }

      <Grid container spacing={2}>
        <Grid item>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="error"
            textColor="error"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              fontFamily: "Geist, sans-serif",
              justifyContent: "flex-start", // Make Tabs align left
              alignItems: "center",
              position: "relative",
              right: "10px",
              "& .MuiTabs-flexContainer": {
                justifyContent: "flex-start", // Tabs content align left
              },
            }}
          >
            {tabs.map((label, index) => (
              <Tab
                key={label}
                label={label}
                sx={{
                  fontFamily: "Geist, sans-serif",
                  background: selectedTab !== index ? "white" : "#006CB8",
                  border:
                    selectedTab !== index
                      ? "1px solid #006CB8"
                      : "2px solid #006CB8",
                  color: selectedTab !== index ? "grey" : "white",
                  fontWeight: selectedTab === index ? "600" : "500",
                  fontSize: selectedTab === index ? "14px" : "12px",
                  letterSpacing: "1px",
                  borderRadius: "10px",
                  margin: "0px 10px 20px", // Add small horizontal margin only
                  minWidth: "150px",
                }}
              />
            ))}
          </Tabs>

          <Paper sx={{ boxShadow: "none" }}>
            {selectedTab === 0 && <BasicInfo candidateData={candidateData} />}
            {selectedTab === 1 && <DocumentList documents={documents} />}
            {/* {selectedTab === 2 && <CandidateInterviewStatus candidateData={candidateData} />} */}
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CandidateProfilePage;
